(ns common.localstorage
  "Persist data with local storage.
   See https://github.com/day8/re-frame-10x/blob/master/src/day8/re_frame_10x/utils/localstorage.cljs."
  (:refer-clojure :exclude [get])
  (:require [common.webstorage :as webstorage]
            [goog.storage.Storage]
            [goog.storage.mechanism.HTML5LocalStorage]))

(def storage (goog.storage.Storage. (goog.storage.mechanism.HTML5LocalStorage.)))

(defn get
  "Get a value from local storage by key"
  ([k] (webstorage/get storage k))
  ([k not-found] (webstorage/get storage k not-found)))

(defn save!
  "Saves a value into local storage"
  [k v]
  (webstorage/save! storage k v))

(defn remove!
  "Remove a value from local storage by key"
  [k]
  (webstorage/remove! storage k))
